export default function initialState() {
  return {
    form: {
      id: null,
      date: new Date(),
      community_id: null
    },
    errorList: null,
    trackingSources: null
  }
};